<!-- ModalsContainer.vue -->
<script setup lang="ts">
import ModalDialogV2 from '@/components/common/ModalDialogV2.vue';
import { useModal } from '@/composables/useModal';

const { modals, close } = useModal();

function onModalOpenChange(id: string, isOpen: boolean) {
  if (!isOpen) close(id);
}
</script>

<template>
  <template v-for="(modal, index) in modals" :key="index">
    <Teleport :to="modal.teleport" :disabled="!modal.teleport">
      <ModalDialogV2
        :model-value="modal.isOpen"
        :title="modal.title"
        :description="modal.description"
        :icon="modal.icon"
        :icon-class="modal.iconClass"
        :type="modal.type"
        :size="modal.size"
        :static="modal.static"
        :hide-actions="modal.hideActions"
        :show-close-button="modal.showCloseButton"
        :center-content="modal.centerContent"
        :show-confirm-button="modal.showConfirmButton"
        :show-cancel-button="modal.showCancelButton"
        :confirm-button-text="modal.confirmButtonText"
        :cancel-button-text="modal.cancelButtonText"
        :invert-buttons="modal.invertButtons"
        :centered="modal.centered"
        :is-loading="modal.isLoading"
        :teleport="modal.teleport"
        @update:model-value="(isOpen) => onModalOpenChange(modal.id, isOpen)"
        @close="modal.onClose?.()"
        @confirm="modal.onConfirm?.()"
        @cancel="modal.onCancel?.()"
      >
        <template v-if="modal.slots?.headerSlot" #header>
          <component :is="modal.slots?.headerSlot" v-bind="modal.slots?.headerProps" />
        </template>

        <template v-if="modal.slots?.iconSlot" #icon>
          <component :is="modal.slots?.iconSlot" v-bind="modal.slots?.iconProps" />
        </template>

        <template v-if="modal.slots?.descriptionSlot" #description>
          <component :is="modal.slots?.descriptionSlot" v-bind="modal.slots?.descriptionProps" />
        </template>

        <template v-if="modal.slots?.footerSlot" #footer>
          <component :is="modal.slots?.footerSlot" v-bind="modal.slots?.footerProps" />
        </template>

        <template v-if="modal.slots?.confirmButtonSlot" #confirmButton>
          <component
            :is="modal.slots?.confirmButtonSlot"
            v-bind="modal.slots?.confirmButtonProps"
          />
        </template>

        <template v-if="modal.slots?.cancelButtonSlot" #cancelButton>
          <component :is="modal.slots?.cancelButtonSlot" v-bind="modal.slots?.cancelButtonProps" />
        </template>

        <component
          v-if="modal.customComponent"
          :is="modal.customComponent"
          v-bind="modal.customComponentProps"
        />
        <div v-else-if="modal.content" v-html="modal.content"></div>
      </ModalDialogV2>
    </Teleport>
  </template>
</template>
